<template>
    <CalendarHome v-if="!isAdmin" />
    <Dashboard v-else />
</template>

<script>
// @ is an alias to /src
import CalendarSmall from "@/components/calendar/CalendarSmall.vue";
import CalendarHome from "@/components/calendar/Home.vue";
import Dashboard from "@/views/Dashboard.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "Home",
  components: {
    Dashboard,
    CalendarHome,
    //CalendarSmall,
  },
  mounted() {
    if(this.isAdmin === false){      
      this.$router.push("/calendar");
    }
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    
  },
};
</script>
